export class UrlParser {
    constructor(url) {
        this.parser = document.createElement('a');
        this.parser.href = url;
        this.Protocol = this.parser.protocol;
        this.HostName = this.parser.hostname;
        this.Port = this.parser.port;
        this.PathName = this.parser.pathname;
        this.Search = this.parser.search;
        this.Hash = this.parser.hash;
        this.Host = this.parser.host;
    }
    get Url() {
        return this.parser.href;
    }
    get Protocol() {
        return this.parser.protocol;
    }
    set Protocol(value) {
        this.parser.protocol = value;
    }
    get HostName() {
        return this.parser.hostname;
    }
    set HostName(value) {
        this.parser.hostname = value;
    }
    get Port() {
        return this.parser.port;
    }
    set Port(value) {
        this.parser.port = value;
    }
    get PathName() {
        return this.parser.pathname;
    }
    set PathName(value) {
        this.parser.pathname = value;
    }
    get Search() {
        return this.parser.search;
    }
    set Search(value) {
        this.parser.search = value;
    }
    get Hash() {
        return this.parser.hash;
    }
    set Hash(value) {
        this.parser.hash = value;
    }
    get Host() {
        return this.parser.host;
    }
    set Host(value) {
        this.parser.host = value;
    }
    get Params() {
        return this.stringToParams(this.Search);
    }
    GetParams(key) {
        let items = [];
        this.Params.each(param => {
            if (param.Key == key) {
                items.push(param);
            }
        });
        return items;
    }
    GetParam(key) {
        let items = this.GetParams(key);
        return items.length > 0 ? items[0] : null;
    }
    SetParam(key, value, replace = true) {
        if (replace) {
            this.RemoveParam(key);
        }
        let prefix = this.Search.indexOf("?") > -1 ? "&" : "?";
        this.Search = this.Search + prefix + key + "=" + value;
    }
    RemoveParam(key) {
        let temp = this.Params;
        for (let i = temp.length - 1; i >= 0; i--) {
            if (temp[i].Key == key) {
                temp.splice(i, 1);
            }
        }
        this.Search = this.paramsToString(temp);
    }
    stringToParams(value) {
        let regex = new RegExp(/(?:\?|&)([\w\d]+)(?:=)([^&=$]+)/gm);
        let matches = [];
        let match;
        while ((match = regex.exec(value)) != null) {
            let key = match[1];
            let val = decodeURIComponent(match[2].replace(/\+/g, ' '));
            matches.push(new UrlParam(key, val));
        }
        return matches;
    }
    paramsToString(params) {
        let output = "";
        for (let i = 0; i < params.length; i++) {
            output += i == 0 ? "?" : "&";
            output += params[i].Key + "=" + params[i].Value;
        }
        return output;
    }
}
export class UrlParam {
    constructor(key, value) {
        this.Key = key;
        this.Value = value;
    }
    get Values() {
        return this.Value.split(",");
    }
}
